import { useCallback } from 'react'
import { cn } from '@global/utils/tailwind'

interface ListItemProps {
  children: React.ReactNode
  disabled?: boolean
  className?: string
  onClick?: () => void
}

export const ListItem = ({
  children,
  className = '',
  disabled = false,
  onClick,
}: ListItemProps) => {
  const clickHandler = useCallback(() => {
    if (disabled) {
      return
    }

    onClick?.()
  }, [disabled, onClick])

  return (
    <div
      tabIndex={0}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          clickHandler()
        }
      }}
      onClick={clickHandler}
      className={cn(
        'item border border-gray-200 rounded-md bg-[#ffffff] mb-6 flex flex-row items-stretch group',
        className,
        {
          'cursor-pointer': !disabled,
          'hover:border-[#3E8FF7]': !disabled,
          'hover:border-1': !disabled,
        },
      )}
    >
      {children}
    </div>
  )
}

const ColumnWrapper = ({ children, className = '' }) => (
  <div className={`grid grid-cols-3 gap-x-6 p-6 flex-grow ${className}`}>{children}</div>
)

const Column = ({ children, className = '' }) => (
  <div className={`flex flex-col justify-center ${className}`}>{children}</div>
)

const Row = ({ children, className = '' }) => <p className={className}>{children}</p>

const Title = ({ children, className = '' }) => (
  <span className={cn('font-bold text-base text-cv-black-900', className)}>{children}</span>
)

const Subtitle = ({ children, className = '' }) => (
  <span className={cn('text-sm text-cv-black-900', className)}>{children}</span>
)

ListItem.ColumnWrapper = ColumnWrapper
ListItem.Column = Column
ListItem.Row = Row
ListItem.Title = Title
ListItem.Subtitle = Subtitle
